export default __webpack_public_path__ + "static/media/microsoft.03f393fd.svg";